import { Inject, Injectable, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateFn,
  Router,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '@nai-libs/app-config';
import { AppConfig, FeatureKey } from '@nai-libs/data-access';

@Injectable({ providedIn: 'root' })
export class FeatureGuard {
  constructor(
    @Inject(APP_CONFIG)
    private _env: AppConfig
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot
  ):
    | boolean
    | UrlTree
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> {
    return !!this._env.features[route.data['featureKey'] as FeatureKey];
  }
}

export const canActivateFeature: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  return inject(FeatureGuard).canActivate(route);
};
